import React from "react";

import "./App.css";

export default function App() {
  return <div className="App">Weather App</div>;
}
